import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Link, Navigate, redirect } from "react-router-dom";
import {
  Autocomplete,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  TextareaAutosize,
} from "@mui/material";
// import Textarea from "@mui/joy/Textarea";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const fd = new FormData();
export default class UpdateEvents extends Component {
  state = {
    message: "",
    notification: false,
    per_pge: 20,
    page_no: 1,
    event_image: {},
    event_name: "",
    testimonial: "",
    links: "",
    event_type: "",
    event_venue: "",
    event_date: "",
    description: "",
    event_details: "",
  };

  componentDidMount() {
    this.getSingleEvent();
  }

  getSingleEvent = async () => {
    if (init() === "success") {
      await axios
        .get(Constants.getUrls.getAllEvents + "/" + window.location.pathname.split("/")[2])
        .then((resp) => {
          // console.log(resp);

          this.setState({
            // client_image: resp.data.data.image,
            event_name: resp.data.data.name,
            event_venue: resp.data.data.event_venue,
            event_date: resp.data.data.event_date,
            description: resp.data.data.event_details,
            event_type: resp.data.data.event_type,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  handleDescription = (e) => {
    // console.log(e);
    this.setState({ description: e });
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    // ✅ Always create fresh FormData
    const fd = new FormData();

    fd.append("name", this.state.event_name);
    fd.append("event_details", this.state.description);
    fd.append("event_venue", this.state.event_venue);
    fd.append("event_date", this.state.event_date);
    fd.append("event_type", this.state.event_type);

    // ✅ Append image ONLY if user selected a new one
    if (this.state.event_image) {
      fd.append("client_image", this.state.event_image);
    }

    if (init() === "success") {
      const eventId = window.location.pathname.split("/")[2];

      axios
        .put(`${Constants.putUrls.updateEvent}${eventId}`, fd, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((resp) => {
          this.setState({
            notification: true,
            message: "Event updated!",
          });

          setTimeout(() => {
            this.setState({
              notification: false,
              message: "",
              redirect: true,
            });
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err?.response?.data?.message || "Failed to update event",
          });

          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 5000);
        });
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/events" />;
    } else {
      return (
        <div>
          <div>
            <DashboardLayout>
              <DashboardNavbar />
              <MDBox pt={6} pb={3}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Update Event
                    </MDTypography>
                  </MDBox>
                  {/* <Grid item sm={4} px={2} align="right">
                    <Link to="/admin/addNewJob">
                      <MDButton variant="contained" size="small" color="primary">
                        Create Job
                      </MDButton>
                    </Link>
                  </Grid> */}
                  <MDBox py={3} px={2}>
                    <form onSubmit={this.handleSubmit}>
                      <Grid container sm={12} spacing={2}>
                        <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Event name"
                            value={this.state.event_name}
                            name="event_name"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <TextField
                            type="datetime-local"
                            name="event_date"
                            value={this.state.event_date}
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required
                            InputLabelProps={{ shrink: true }} // Ensures label does not overlap with input
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Event Venue"
                            value={this.state.event_venue}
                            name="event_venue"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%", top: "13px" }}
                          />
                        </Grid>

                        <Grid item sm={6}>
                          <InputLabel>Select Event Type</InputLabel>
                          <Select
                            value={this.state.event_type}
                            onChange={(e) => this.setState({ event_type: e.target.value })}
                            name="event_type"
                            label="Select Event Type"
                            // style={{
                            //   height: "45px",
                            // }}
                            required
                            style={{ width: "100%", height: "45px", color: "#fff" }}
                          >
                            <MenuItem value="">Event Type</MenuItem>

                            <MenuItem value="offline" style={{ color: "#fff" }}>
                              Offline
                            </MenuItem>
                            <MenuItem value="online" style={{ color: "#fff" }}>
                              Online
                            </MenuItem>
                          </Select>
                        </Grid>

                        <Grid item sm={6}>
                          <TextField
                            type="file"
                            label="Alumini Image"
                            name="event_image"
                            focused
                            onChange={(e) => {
                              this.setState({
                                event_image: e.target.files[0],
                              });
                            }}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>
                        <Grid item sm={12}>
                          <SunEditor
                            // width="120%"
                            setDefaultStyle="font-family: Arial; font-size: 16px;"
                            setOptions={{
                              buttonList: [
                                ["undo", "redo"],
                                ["font", "fontSize"],
                                ["paragraphStyle", "blockquote"],
                                [
                                  "bold",
                                  "underline",
                                  "italic",
                                  "strike",
                                  "subscript",
                                  "superscript",
                                ],
                                ["fontColor", "hiliteColor"],
                                ["align", "list", "lineHeight"],
                                ["outdent", "indent"],

                                ["table", "horizontalRule", "link", "image", "video"],
                                // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
                                ["imageGallery"], // You must add the "imageGalleryUrl".
                                // ["fullScreen", "showBlocks", "codeView"],
                                ["preview", "print"],
                                ["removeFormat"],

                                // ["save", "template"],
                                // '/', Line break
                              ], // Or Array of button list, eg. [['font', 'align'], ['image']]
                              defaultTag: "div",
                              height: 120,
                              showPathLabel: false,
                              // font: sortedFontOptions
                            }}
                            name="description"
                            setContents={this.state.description}
                            onChange={this.handleDescription}
                          />
                        </Grid>
                      </Grid>

                      <Grid align="left" mt={2}>
                        <MDButton variant="contained" size="small" color="info" type="submit">
                          {this.state.loading ? "Updating..." : "Update"}
                        </MDButton>
                      </Grid>
                    </form>
                  </MDBox>
                  <>
                    <MDSnackbar
                      color="success"
                      icon="notifications"
                      title="VASA Events"
                      content={this.state.message}
                      dateTime="Just now"
                      open={this.state.notification}
                      //   close={toggleSnackbar}
                    />
                  </>
                </Card>
              </MDBox>
            </DashboardLayout>
          </div>
        </div>
      );
    }
  }
}
